import { N12_02 } from "./N12_02";

export const N12_01 = {
  selectedValueColumn: "Title",
  selectedTitle: "Region",
  visual: [
    {
      columns: 12,
      rows: 2,
      visual: {
        id: 1,
        type: "advancedTable",
        colorTheme: "colorTheme1",
        title: "Region",
        binding: {
          data: {
            columns: [
              {
                name: "Region",
                columnName: "RegionName",
                width: "450px",
                align: "left",
                sortable: true
              },
              {
                name: "Actual Visits",
                columnName: "Coverage",
                width: "180px",
                align: "center",
                sortable: true
              },
              {
                name: "Planned Visits",
                columnName: "Target",
                width: "180px",
                align: "center",
                sortable: true
              },
              {
                name: "Call Rate",
                columnName: "CallRate",
                width: "180px",
                align: "center",
                sortable: true,
                percent: true
              },
            ],
            title: "RegionName",
            endpoint: "SFE_N12.1",
            parameters: [
                { key: "CycleCode", value: "CP1" },
                { key: "CycleYear", value: "2026" },
            ],
          },
          context: {
            point: {
              onClick: N12_02,
            },
          },
        },
      },
    },
  ],
};